module.exports = __webpack_public_path__ + "assets/img/Aloading.75dc6c4b.gif";